import { useQuery } from 'react-query';
import { AppConfig, FhirBundlePatient } from '@oh-vcp/components-common';
import { apiGet } from './apiService';

const rewriteNextUrl = (nextUrl: string): string => {
  const next = new URL(nextUrl);
  const base = new URL(AppConfig.baseSofLaunchUrl);
  next.protocol = base.protocol;
  next.host = base.host;
  next.pathname = '/fhir';
  return next.toString();
};

const fetchAllPages = async (url: string): Promise<FhirBundlePatient> => {
  let nextUrl: string | null = url;
  let combinedData: FhirBundlePatient | null = null;

  while (nextUrl) {
    const page: FhirBundlePatient = await apiGet(nextUrl);

    if (!combinedData) {
      combinedData = { ...page };
    } else {
      combinedData.entry = [...(combinedData.entry ?? []), ...(page.entry ?? [])];
    }

    const nextLink = page.link?.find((l: { relation: string }) => l.relation === 'next');
    nextUrl = nextLink?.url ? rewriteNextUrl(nextLink.url) : null;
  }

  return combinedData!;
};

const useSmartOnFhirPatientData = (resourceType: string, patientGuid: string | undefined) => {
  return useQuery({
    enabled: !!patientGuid,
    refetchOnWindowFocus: false,
    retry: 0,
    queryFn: () =>
      fetchAllPages(`${AppConfig.baseSofLaunchUrl}/fhir/${resourceType}?patient=${patientGuid}`),
    queryKey: ['useSmartOnFhirPatientData', resourceType, patientGuid]
  });
};

export default useSmartOnFhirPatientData;
